module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-combobox', {
    staticClass: "compact",
    attrs: {
      "items": _vm.itemsFormatted,
      "multiple": "",
      "chips": "",
      "return-object": "",
      "hide-details": "",
      "label": _vm.label
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', _vm.selectedItemsFormatted)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": _vm.getImage(data.item)
          }
        })]), _vm._v(" "), _c('v-list-item-content', [_c('v-list-item-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        }), _vm._v(" "), _c('v-list-item-subtitle', {
          domProps: {
            "innerHTML": _vm._s(data.item.email)
          }
        })], 1)]
      }
    }, {
      key: "selection",
      fn: function(data) {
        return [_c('v-tooltip', {
          attrs: {
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-chip', _vm._g({
                staticClass: "chip--select-multi",
                attrs: {
                  "input-value": data.selected,
                  "close": ""
                },
                on: {
                  "click:close": function($event) {
                    return _vm.remove(data.item)
                  }
                }
              }, on), [_c('v-avatar', {
                staticStyle: {
                  "height": "40px",
                  "width": "40px",
                  "margin-right": "10px"
                }
              }, [_c('img', {
                attrs: {
                  "src": _vm.getImage(data.item)
                }
              })]), _vm._v("\n                " + _vm._s(data.item.text) + "\n            ")], 1)]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getHintText(data.item)))])])]
      }
    }]),
    model: {
      value: (_vm.selectedItemsFormatted),
      callback: function($$v) {
        _vm.selectedItemsFormatted = $$v
      },
      expression: "selectedItemsFormatted"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b901ed9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ContactAutocomplete.vue
// module id = 2590
// module chunks = 1